import { useLocation, useNavigate } from "react-router-dom";
import { useLiveQuizSocket } from "../../contexts/LiveQuizSocketContext";
import { useTranslation } from "../../hooks/useTranslation";

export default function LiveQuizHostRejoinBanner() {
    const { socket, hostActiveRoom, setHostActiveRoom } = useLiveQuizSocket();
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();

    if (!hostActiveRoom) return null;
    if (location.pathname.startsWith("/livequiz/")) return null;

    const handleRejoin = () => {
        if (socket && socket.connected) {
            socket.emit("join_room", { roomCode: hostActiveRoom.roomCode });
        }
        navigate(`/livequiz/lobby/${hostActiveRoom.roomCode}`);
    };

    const handleClose = () => {
        if (socket && socket.connected) {
            socket.emit("close_room", { roomCode: hostActiveRoom.roomCode });
        }
        setHostActiveRoom(null);
    };

    return (
        <div style={{
            position: "fixed", top: 0, left: 0, right: 0, zIndex: 9998,
            background: "#1368ce", color: "white",
            display: "flex", alignItems: "center", justifyContent: "space-between",
            padding: "10px 20px", boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        }}>
            <span style={{ fontWeight: 600, fontSize: "0.95rem" }}>
                {t.liveQuiz.quizRunning} <strong>{hostActiveRoom.quizTitle}</strong>
            </span>

            <div style={{ display: "flex", gap: 10 }}>
                <button
                    onClick={handleRejoin}
                    style={{
                        background: "white", color: "#1368ce", border: "none",
                        borderRadius: 20, padding: "4px 16px",
                        fontWeight: 700, cursor: "pointer", fontSize: "0.9rem",
                    }}
                >
                    {t.liveQuiz.rejoinAsHost}
                </button>
                <button
                    onClick={handleClose}
                    style={{
                        background: "transparent", color: "white",
                        border: "1px solid rgba(255,255,255,0.4)",
                        borderRadius: 20, padding: "4px 12px",
                        cursor: "pointer", fontSize: "0.85rem",
                    }}
                >
                    ✕
                </button>
            </div>
        </div>
    );
}
